<app-avis-initial-type
  [uid]="getUid()"
  [parentForm]="parentForm"
  [disabled]="disabled"
  [avisInitial]="attributionFromMAPA.avisInitial"
>
</app-avis-initial-type>
<app-form-input
  *ngIf="false"
  [parentForm]="parentForm"
  [disabled]="disabled"
  [value]="attributionFromMAPA.pasAvisInitial"
  [label]="'step1.getpasavisinitial'"
  [type]="'text'"
  [rule]="'pattern_29'"
  [name]="getUid() + '_SepAtt_pasAvisInitial'">
</app-form-input>
